import { render, staticRenderFns } from "./SchemaTree.vue?vue&type=template&id=20fc226c&scoped=true&"
import script from "./SchemaTree.vue?vue&type=script&lang=js&"
export * from "./SchemaTree.vue?vue&type=script&lang=js&"
import style0 from "./SchemaTree.vue?vue&type=style&index=0&id=20fc226c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fc226c",
  null
  
)

export default component.exports